interface NumberInputProps {
  readonly id: string
  readonly label: string
  readonly value: number
  readonly onChange: (v: number) => void
  readonly min?: number
  readonly max?: number
  readonly step?: number
  readonly disabled?: boolean
  readonly labelClassName?: string
  readonly className?: string
  readonly containerClassName?: string
}

/**
 * Labeled number input with Telegram theme styling.
 * Renders a <label> above a <input type="number">.
 * The `onChange` callback receives the parsed number directly.
 */
export function NumberInput({
  id,
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled = false,
  labelClassName = '',
  className = '',
  containerClassName = '',
}: NumberInputProps) {
  return (
    <div className={`flex flex-col gap-1 ${containerClassName}`}>
      <label
        htmlFor={id}
        className={`text-xs font-medium text-tg-hint ${labelClassName}`}
      >
        {label}
      </label>
      <input
        id={id}
        type="number"
        value={value}
        onChange={(e) => { onChange(Number(e.target.value)) }}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        className={`w-full rounded-lg border border-tg-hint/20 px-3 py-2 text-sm outline-none input-focus bg-tg-secondary text-tg-text disabled:opacity-50 ${className}`}
      />
    </div>
  )
}
